export default "__VITE_ASSET__951fb140__"